var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1172,
    height: 1090,
    viewBox: "0 0 1172 1090",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.5 191C101.233 426.134 -36.7698 357.159 9.00317 703.999C25.4996 828.999 273.329 824.431 362.502 891.999C556.502 1039 645.002 894.499 746.002 995.499C819.502 1069 1005.41 1138.5 1098 1042.5C1190.59 946.5 1169.5 891.999 1169.5 729.999C1169.5 626.499 963.002 612.313 1046 530.998C1139.39 439.5 1227.03 315.395 1046 191.001C725.918 -23.1531 656.004 -100.998 362.5 191Z",
    fill: "#FFEEEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBlob);
export default __webpack_public_path__ + "static/media/red-blob.ef3c5d9baf006af93552645353b9f087.svg";
export { ForwardRef as ReactComponent };